export default __webpack_public_path__ + "static/media/Meteo_Logo-primary.97279743.svg";